module.exports = __webpack_public_path__ + "static/media/doll.85ef0c4e.png";